import { render } from "./ForeignTradeTurnoverWorld.vue?vue&type=template&id=48e8b2d9"
import script from "./ForeignTradeTurnoverWorld.vue?vue&type=script&lang=js"
export * from "./ForeignTradeTurnoverWorld.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__